import type { ComplianceMonitoringAssessmentTestResultsByControlIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetLatestOversightAssessmentTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestOversightAssessmentTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestOversightAssessmentTestResultsByControlIdArgs = {
  controlId: string;
};

export const useGetLatestOversightAssessmentTestResultsByControlId =
  createQueryHook<
    UseGetLatestOversightAssessmentTestResultsByControlIdArgs,
    ComplianceMonitoringAssessmentTestResultsByControlIdResponseRow[],
    GetLatestOversightAssessmentTestResultsByControlIdQuery
  >({
    trpcQueryOptions: (trpc, { controlId }) =>
      trpc.frontend.testResult.latestComplianceMonitoringAssessmentTestResultsByControlId.queryOptions(
        { controlId }
      ),
    mapTrpcDataToGraphQL: (data) =>
      ({
        control_test_oversight_result: data[0] ? [data[0]] : [],
      }) as unknown as GetLatestOversightAssessmentTestResultsByControlIdQuery,
    graphqlDocument: GetLatestOversightAssessmentTestResultsByControlIdDocument,
    graphqlVariables: ({ controlId }) => ({ controlId }),
  });
